import React from "react";
import { Link } from "react-router-dom";
import { PROFILE } from "../lib/data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-black/5 py-10">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-foreground/50">
          © {new Date().getFullYear()} {PROFILE.name}. Crafted with care.
        </p>
        <div className="flex items-center gap-6 text-sm">
          <a href={`mailto:${PROFILE.email}`} className="text-foreground/60 hover:text-primary transition-colors">
            Email
          </a>
          <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" className="text-foreground/60 hover:text-primary transition-colors">
            LinkedIn
          </a>
          <Link to="/admin" data-testid="footer-admin-link" className="text-foreground/40 hover:text-primary transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
